import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImageGenerationService {
  private apiUrl = environment.apiBaseUrl || 'http://localhost:5000';

  constructor(private http: HttpClient) {}

  async generateImage(prompt: string, size: string = '1024x1024', quality: string = 'standard', style: string = 'vivid', model: string = 'dall-e-3'): Promise<string> {
    try {
      const response = await firstValueFrom(
        this.http.post<any>(`${this.apiUrl}/api/v1/azure/generate-image`, {
          prompt,
          size,
          quality,
          style,
          model  // Send the model to backend
        })
      );
      
      if (response.status === 'success' && response.image_url) {
        return response.image_url;
      } else {
        throw new Error(response.error || 'Failed to generate image');
      }
    } catch (error: any) {      const errorMessage = error?.error?.error || error?.message || 'Failed to generate image. Please try again.';
      throw new Error(errorMessage);
    }
  }
}

